<template>
  <div class="text-question-wrapper">
  <div v-if="question" class="text-question">
    <h2>{{ question.intro }}</h2>
    <div class="text-question-options">
      <div class="content-wrapper">
      <div class="text-options" :class="{
        'grid-repeat-2': question.config.options.length >= 2,
        'grid-repeat-4': question.config.options.length >= 4,
        'grid-repeat-6': question.config.options.length >= 6
        }">
        <div
          v-for="option in question.config.options"
          :key="option.value"
        >
          <div>
          <div v-if="question.config.max > 1">
            <b-form-checkbox
              :id="'check'+option.value"
              v-model="answers"
              :value="option.value"
            >
              {{option.title}}
              <b-button
              v-if="option.info"
              variant="link"
              :id="'popover' + option.value"
              class="popover-btn"
            >
              <img src="../../assets/images/info-i.svg" alt="Info Toggle" />
            </b-button>
            <b-popover
              v-if="option.info"
              :target="'popover' + option.value"
              :content="option.info"
              triggers="hover focus"
              placement="topright"
              style="background-color: #1a1a1a; color: #ffffff"
            ></b-popover>
            </b-form-checkbox>
          </div>
          <div v-if="question.config.max === 1">
            <b-form-radio
              :id="'radio'+option.value"
              v-model="preSelect"
              :value="option.value"
              @change="updateRadio()"
            >
              {{option.title}}
              <b-button
              v-if="option.info"
              variant="link"
              :id="'popover' + option.value"
              class="popover-btn"
            >
              <img src="../../assets/images/info-i.svg" alt="Info Toggle" />
            </b-button>
            <b-popover
              v-if="option.info"
              :target="'popover' + option.value"
              :content="option.info"
              triggers="hover focus"
              placement="topright"
              style="background-color: #1a1a1a; color: #ffffff"
            ></b-popover>
            </b-form-radio>
          </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
  
</template>

<script>
export default {
  name: 'TextQuestion',
  data () {
    return {
      openedModal: null,
      preSelect: ""
    }
  },
  mounted (){
    if(this.question.config.max === 1 && this.question.selectedAnswers.length === 0){
      this.updateRadio();
    } else{
      this.preSelect = this.question.selectedAnswers;
    }
  },
  computed: {
    question: function () {
      return this.$store.state.questions[0] || false
    },
    answers: {
      get () {
        return this.question.selectedAnswers ?? ''
      },
      set (value) {
        this.$store.commit('updateSelectedAnswers', value)
      }
    }
  },
  methods: {
    showModal (id, ev) {
      ev.preventDefault()
      this.openedModal = id
    },
    activeOption (value) {
      if (this.question.config.max == 1 && value == this.answers) {
        return true
      }
      if (this.question.config.max > 1 && this.answers.includes(value)) {
        return true
      }
      return false
    },
    updateRadio(){
      if(this.question.selectedAnswers && this.question.config.options){
        if(this.question.selectedAnswers.length === 0 && this.question.config.options.length !== 0){
          this.preSelect = this.question.config.options[0].value;
        }
        if(this.preSelect){
          this.$store.commit('updateSelectedAnswers', this.preSelect);
        }
      }
    }
  }
}
</script>
